














































































































































































import BaseComponent from "@/asdcom/BaseComponent"
import { Component, Vue, Inject } from "vue-property-decorator";
import VueRecaptcha from "vue-recaptcha";
import { Asdcom } from "@/asdcom/appservice.asdcom";
import { IRegisterInput, UserCategory, RegisterInput, RegisterOutput } from "@/asdcom/apiproxy/apiproxy.dto";

// class SignInModel {
//   constructor(data: SignInModel | null = null) {
//     this.userCategory = data && data.userCategory ? data.userCategory : undefined;
//     this.name = data.name;
//     this.surname = data && data.surname ? data.surname : null;
//     this.userName = data && data.userName ? data.userName : null;
//     this.password = data && data.password ? data.password : null;
//     this.emailAddress = data && data.emailAddress ? data.emailAddress : null;
//     if (data && data.captchaResponse) {
//       this.captchaResponse = data.captchaResponse;
//     }
//   }
//   userCategory:  UserCategory | undefined;
//   name: string;
//   surname: string;
//   userName: string;
//   emailAddress: string;
//   password: string;
//   captchaResponse?: string | null | undefined;
// }

@Component({
  components: { VueRecaptcha }
})
export default class CreateAccount extends BaseComponent {
  accountService = new Asdcom.AccountAppService();
  reservedEmails = [];
  siteKey: string = "";
  accountCreated: boolean = false;
  passwordConfirm: string = "";
  signInModel: RegisterInput = new RegisterInput();
 
  recaptchaOnRender() {
    (<any>window).grecaptcha.reset();
  }
  
  async submit() {
    this.ValidateAll().then(async (isValid: boolean) => {
      if (isValid) {
        //if (this.isProduction) {
          // payload.captchaResponse = this.signInModel.captchaResponse;
          // abp.log.debug({"signInModel.captchaResponse": this.signInModel.captchaResponse});
        //}
          // abp.log.debug({"this.siteKey": this.siteKey});

        this.accountService.register(this.signInModel)
        .then((rep: RegisterOutput) => {
          if (rep) { 
            const data = rep;
            this.accountCreated = true;
          } 
        })
        .catch(err=>{
          this.recaptchaOnRender();
        });
      }
    });
  }

  public recaptchaCallback(recaptchaResponse: string): void {
    //abp.log.debug({"recaptchaResponse":recaptchaResponse})
    //if (this.isProduction) {
      this.signInModel.captchaResponse = recaptchaResponse;
    //}
  }

  showFillButton(){
      return this.$store.getters["asdcom/session/useFillButton"];
  }

  computedEmailAddress() {
    return this.signInModel.emailAddress
  }

  public back(): void {
    this.$router.push("/");
  }

  private created() {
    this.siteKey = abp.setting.values["Recaptcha.SiteKey"];
  }

  get isProduction() {
    return process.env.NODE_ENV === "production";
  }

  private fill(): void {
    this.signInModel = new RegisterInput({
      userCategory: UserCategory.ConsumerUser,
      name: "John",
      surname: "Doe",
      userName: "JohnDoe",
      emailAddress: "JohnDoe@gmail.com",
      password: "123123",
      captchaResponse: ""
    });
  }
}
